import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Simple page header with a back button + title (used by pushed screens). */
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [NgIf, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .bb-ph { flex-shrink: 0; display: flex; align-items: center; gap: 12px; padding: 12px 14px; padding-top: var(--bb-top);
      background: var(--fr-surface); border-bottom: 1px solid var(--fr-border); position: relative; z-index: 20; }
    :host-context(.fr-root.bb-desktop) .bb-ph { padding: 14px 32px; }
    :host-context(.fr-root.bb-desktop) .bb-ph-in { max-width: 1280px; margin: 0 auto; width: 100%; display: flex; align-items: center; gap: 12px; }
    .bb-ph-in { display: contents; }
  `],
  template: `<div class="bb-ph"><div class="bb-ph-in">
      <button (click)="back.emit()"
        style="height:42px;padding:0 14px 0 9px;border-radius:12px;border:none;cursor:pointer;display:flex;align-items:center;gap:3px;
               background:var(--fr-surface);box-shadow:inset 0 0 0 1.5px var(--fr-border-2);font-family:var(--fr-font);
               font-weight:700;font-size:13.5px;color:var(--fr-text);flex-shrink:0">
        <app-icon name="solar:alt-arrow-left-linear" [size]="18"></app-icon> {{ 'Back' | t }}
      </button>
      <div style="flex:1;min-width:0">
        <h2 style="margin:0;font-size:17px;font-weight:750;letter-spacing:-0.02em;color:var(--fr-text);
            overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ title | t }}</h2>
        <div *ngIf="sub" style="font-size:12px;color:var(--fr-text-3);margin-top:1px">{{ sub | t }}</div>
      </div>
      <ng-content></ng-content>
    </div></div>`,
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() sub?: string;
  @Output() back = new EventEmitter<void>();
}
